module.exports = __webpack_public_path__ + "static/media/verify-otp.6655c56b.svg";